// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2oXW5","footer":"ModalInfo_footer__3Nnbo"};